import {globalVar} from 
    "./../../../../variables/global_variables.js";

import {SmetioSideMenuItem} from
    "./../../../../classes/smetioSideMenuItem/SmetioSideMenuItem.js";
        
export function all_leftSideMenu_is_loaded(result){


    /**** 
    
        SORT ALL THE MENU ITEMS ACCORDING TO THEIR POSITIONS
    
    ****/           
                                      

    let allMenu_items = "";
    
    let allOpenOnClick = "";
    
    let resultObj = JSON.parse(result);
    
    for(let key in resultObj){ 
               
        let menuItem = resultObj[key];

        for(let key in menuItem){ 
            
            const smetioSideMenuItem = new SmetioSideMenuItem();
            
            let token = menuItem[key]["token"].toLowerCase();
            
            let textToken = menuItem[key]["textToken"];
            
            smetioSideMenuItem.id = token;

            smetioSideMenuItem.extraClass = "smetio-app-ui-left_sideMenuItem";

            smetioSideMenuItem.tab_toggle_id = token+"_openOnClick";
                
            smetioSideMenuItem.isActive = menuItem[key]["isActive"];

            smetioSideMenuItem.icon = menuItem[key]["icon"];

            smetioSideMenuItem.text = menuItem[key]["readableText"];

            smetioSideMenuItem.textToken = textToken;
            
            globalVar.text_on_page[textToken] = menuItem[key]["readableText"];

            allMenu_items += smetioSideMenuItem.render();
            
            allOpenOnClick += smetioSideMenuItem.openOnClick_divs;
        
        };
    
    };

    $("#smetio-app-ui-body-section-1").html(allMenu_items);
    
    $("#smetio-content").html(allOpenOnClick);
    
};
